import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoAr: CultureInfo = {
  name: 'ar',
  displayName: 'Arabic',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar',
  parent: null
};
